export default __webpack_public_path__ + "static/media/BANNER-FULL_Covid_02_Nasal.c273e1a8.png";